import { ReactElement, ReactNode } from "react";

import Condition from "../../../Conditional/Condition";
import { IAccordionSelection } from "./types";
import { useAccordionSelectionDisplay } from "./useAccordionSelectionDisplay";

interface IProps {
	label: ReactNode;
	options: IAccordionSelection[];
	selected: string[];
}

const AccordionSummaryDisplay = ({ label, selected, options }: IProps): ReactElement => {
	const selection_display = useAccordionSelectionDisplay(options, selected);

	return (
		<Condition check={selection_display.length > 0} failDisplay={label}>
			<div className="SummaryContainer">
				{selection_display.map(({ display: { id, selected_display }, count }, idx) => (
					<div key={`${id}-${idx}`} className="SelectionEntry">
						<div>{selected_display}</div>
						<Condition check={count > 1}>
							<div className="Count">{`x${count}`}</div>
						</Condition>
					</div>
				))}
			</div>
		</Condition>
	);
};

export default AccordionSummaryDisplay;
